import type { WebModule } from "../../modules";
import { Icon } from "../ui/icon";

export function Topbar({
  modules,
  onMenu,
  navOpen,
}: {
  modules: WebModule[];
  onMenu: () => void;
  navOpen: boolean;
}) {
  const slots = modules.filter((m) => m.topbar);
  return (
    <div className="topbar">
      <button
        type="button"
        className="topbar__menu"
        onClick={onMenu}
        aria-label={navOpen ? "Fermer le menu" : "Ouvrir le menu"}
        aria-expanded={navOpen}
        aria-controls="app-sidebar"
      >
        <Icon name={navOpen ? "close" : "menu"} size={20} />
      </button>
      <div className="topbar__left">
        {slots.map((m) => (
          <div key={m.name} className="topbar__slot">
            {m.topbar}
          </div>
        ))}
      </div>
    </div>
  );
}
